import * as tslib_1 from "tslib";
import createAPI from './create-api';
const api = createAPI(process.env.MUJI_APP_SSO_HOST, {
    showNotification: false,
});
export function getSSOUserInfo() {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        return api.jsonp('httpApi/getAuthZ.jsonp');
    });
}
